import React from 'react';
import DealsConfiguration from './DealsConfiguration';
import RewardsConfiguration from './RewardsConfiguration';
import { useAppSelector } from 'utilities/redux';

type TabContentType = {
  index: number;
};

const TabContent: React.FC<TabContentType> = ({ index }) => {
  const activeTab = Number(index);
  const { admin } = useAppSelector(state => state.loginReducer);
  return (
    <>
      {((!admin.dealAccess && activeTab === 0) || activeTab === 1) && <RewardsConfiguration />}
      {admin.dealAccess && activeTab === 0 && <DealsConfiguration />}
    </>
  );
};

export default TabContent;
